import { profileClient } from '@/clients/profile-client.js';

type Listener = () => void;

class EntitlementsService {
    private _entitlements: Record<string, boolean> = {};
    private _listeners: Set<Listener> = new Set();

    async load(): Promise<void> {
        try {
            this._entitlements = await profileClient.getEntitlements();
            this._notify();
        } catch {
            // non-fatal: entitlements stay empty, all gates return false
        }
    }

    has(key: string): boolean {
        return this._entitlements[key];
    }

    applyTo(root: Element | ShadowRoot): void {
        root.querySelectorAll<HTMLElement>('[hat-entitlement]').forEach(el => {
            const keys = el.getAttribute('hat-entitlement')!.trim().split(/\s+/);
            el.style.display = keys.some(k => this.has(k)) ? '' : 'none';
        });
    }

    subscribe(listener: Listener): () => void {
        this._listeners.add(listener);
        return () => this._listeners.delete(listener);
    }

    private _notify() {
        this._listeners.forEach(l => l());
    }
}

export const entitlementsService = new EntitlementsService();